import axios from "axios";

import { toast } from "react-toastify";
import { signoutRequest } from "../openid/openid-manager";
import { isLoaderUnavailableRoute } from "../../shared/helpers/is-loader-unavailable-route";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_CUSTOM_AUTH,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  function (config) {
    const isLoaderUnavailable = isLoaderUnavailableRoute(
      config.url,
      config?.method,
    );

    if (
      isLoaderUnavailable ||
      (config?.method == "get" &&
        !config.url?.includes("slpapp/Menu/getMenuPermissionsByRole"))
    ) {
      // Do not show loader
    } else {
      document.body.classList.add("loading-indicator");
    }

    return config;
  },
  function (error) {
    document.body.classList.remove("loading-indicator");

    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    document.body.classList.remove("loading-indicator");

    const { method } = response.config;

    if (method === "put" || method === "post" || method === "delete") {
      if ([200, 201].includes(response?.data?.status)) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
        });
      } else if ([204, 400, 401, 403, 404].includes(response?.data?.status)) {
        toast.warning(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          draggable: true,
          pauseOnHover: true,
        });
      } else {
        toast.error(
          response?.data?.message
            ? response?.data?.message
            : response?.data?.error,
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
          },
        );
      }
    }

    return response;
  },
  function (error) {
    document.body.classList.remove("loading-indicator");

    if (error?.response?.status === 401) {
      signoutRequest(false);
    }

    const { method } = error.config;
    if (method === "put" || method === "post" || method === "delete") {
      toast.error("An error occurred", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      });
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
